export default {
  'm-verify-code-input': {
    countdown: '{timeLeft} seconds remaining',
    'send-code': 'Send Code',
    'resend-code': 'Resend',
    'no-api-url': 'API URL not configured',
    'no-email': 'Email address not specified',
    'request-in-progress': 'Request in progress, please try again later',
    'wait-retry': 'Please try again later, {timeLeft} seconds remaining',
    'send-success': 'Verification code sent successfully',
    'send-failed': 'Failed to send verification code, please try again',
    'phone-not-implemented': 'Phone verification is not yet implemented',
    'unsupported-type': 'Unsupported verification type: {type}',
    placeholder: {
      default: 'Enter verification code',
      email: 'Enter email verification code',
      phone: 'Enter phone verification code',
    },
  },
}
